import { apidel, apiput, apipost, apiget } from "../../api";

export const types = {
  GET_PROJECTS: "GET_PROJECTS",
  TOGGLE_PROJECT_STATUS: "TOGGLE_PROJECT_STATUS",
  CREATE_PROJECT: "CREATE_PROJECT",
  GET_PROJECT: "GET_PROJECT",
  GET_PROJECT_BY_UUID: "GET_PROJECT_BY_UUID",
  GET_PROJECT_BY_UUID_D: "GET_PROJECT_BY_UUID_D",
  GET_PROJECT_BY_ID: "GET_PROJECT_BY_ID",
  DELETE_PROJECT: "DELETE_PROJECT",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  ASK_NEW_PROJECT: "ASK_NEW_PROJECT",
  SET_CANONICAL_PDF: "SET_CANONICAL_PDF",
  GET_PROJECTS_BY_IDS_D: "GET_PROJECTS_BY_IDS_D"
};

export const additions = {
  PARTNERS: "partners",
  INTERLOCUTEURS: "interlocuteurs",
  INTERLOCUTEURS_D: "interlocuteurs_d",
  SURFACES_D: "surfaces_d",
  DATES: "dates",
  AWARDS: "awards",
  NORMES: "normes",
  TYPOLOGIES: "typologies",
  PROCEDURES: "procedures",
  PROGRAMS: "programs",
  CONTACTS: "contacts"
};

export const sortmodes = {
  BY_ID: "id",
  BY_NAME: "name",
  BY_IN_PROGRESS: "in_progress"
};

export const actions = {
  [types.GET_PROJECTS]: token => async () =>
    await apiget("/projects", {}, token),
  [types.GET_PROJECT]: token => async (_, id) =>
    await apiget(`/project/${id}`, id, token),
  [types.GET_PROJECT_BY_ID]: token => async (_, { id }) =>
    await apiget(`/project/${id}`, {}, token),
  [types.GET_PROJECT_BY_UUID]: token => async (_, { uuid, appends = null }) =>
    await apiget(`/project/${uuid}`, { appends }, token),
  [types.GET_PROJECT_BY_UUID_D]: token => async (_, { uuid, appends = null }) =>
    await apiget(`/project_d/${uuid}`, { appends }, token),
  [types.DELETE_PROJECT]: token => async (_, id) =>
    await apidel(`/project/${id}`, {}, token),
  [types.UPDATE_PROJECT]: token => async (_, project) =>
    await apiput(`/project/${project.id}`, project, token),
  [types.ASK_NEW_PROJECT]: token => async () =>
    await apipost(`/projects`, {}, token),
  [types.TOGGLE_PROJECT_STATUS]: token => async (_, project) =>
    await apipost(`/project/${project.id}/toggle`, {}, token),
  [types.GET_PROJECTS_BY_IDS_D]: token => async (_, idString) =>
    await apiget(
      `/projects/${idString}`,
      { appends: [additions.SURFACES_D] },
      token
    ),
  [types.SET_CANONICAL_PDF]: token => async (_, project) => {
    await apipost(
      `/project/pdf/${project.uuid}`,
      { canonical_pdf: project.canonical_pdf },
      token
    );
  }
};
